// В.2.e-2 / В.2.cards-2A: Подопытный Альфа (liv_podopytnyy_alfa, epic, 1/2/6).
//
// Был 3/1/7 + passive «не выбирается целью Действий и атаки Героя» (untargetable).
// В В.2.cards-2A:
//   - статы 1/2/6 (через xlsx, gen-cards уже выполнен);
//   - passive untargetable УДАЛЕНА — Альфа теперь обычная цель;
//   - триггер «при уроне +1/0/0 за каждый потерянный ХП» оставлен.
//
// Молчание Альфы блокирует триггер on_damage_taken (через каркас).

import { registerOnDamageTakenTrigger } from './on-damage-triggers.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { applyPermanentBuff } from '../../buffs.js';

export const CARD_ID = 'liv_podopytnyy_alfa';
const LABEL = 'Подопытный Альфа';

registerImplementedAbility(CARD_ID, 'trigger');

// Триггер: за каждый потерянный ХП → +1 atk через applyPermanentBuff.
// В.2.i-fix1: nullsafe относительно state — некоторые источники урона
// (Ковровая бомбардировка, Никоси-актив, Бот опергруппы, Парамедик и др.)
// не передают opts.state в applyDamage. +atk должен сработать в любом случае,
// лог пишется только если state доступен.
registerOnDamageTakenTrigger(CARD_ID, (state, alfa, damageToHp) => {
  if (!alfa || damageToHp <= 0) return;
  applyPermanentBuff(state, alfa, { atk: damageToHp, armor: 0, hp: 0 }, CARD_ID, LABEL);
  state?.log?.add?.(
    `🩸 ${LABEL} [${state?.players?.[alfa.ownerId]?.name || '?'}]: -${damageToHp} ХП → +${damageToHp}/0/0 (всего atk: ${alfa.current.atk})`
  );
});
